// Máscara para campos do tipo CNAE (código nacional de atividade econômica)
angular.module("avlib").directive("avCnaeMask", function(){
	return {
		require: 'ngModel',
		link: function(scope, elem, attrs, ctrl){

			var formatCnae = function(value){
				if (value == null || value == ""){
					ctrl.$setValidity("cnae", true);
					return value;
				}
				// Removendo todos os caracteres não numéricos:
				value = value.replace(/\D/g,'');

				// Acrescentando os devidos separadores, de acordo com o tamanho atual do número:
				if (value.length > 4){
					value = value.substr(0,4) + "-" + value.substr(4);

					if (value.length > 6){
						value = value.substr(0,6) + "/" + value.substr(6);

						// Eliminando dígitos em excesso:
						if (value.length > 9){
							value = value.substr(0,9);
						}
					}
				}
				ctrl.$setValidity("cnae", value.length == 9);
				return value;
			};

			var cnaeParser = function(viewValue){
				var formattedCnae = formatCnae(viewValue);
				ctrl.$setViewValue(formattedCnae);
				ctrl.$render();
				if (formattedCnae && formattedCnae.match(/\d{4,4}-\d\/\d{2,2}/)){
					return formattedCnae.replace(/\D/g,'');
				}else{
					return null;
				}
			};

			var cnaeFormatter = function(viewValue){
				if (viewValue){
					var modelValue = (""+viewValue).replace(/\D/g,'')
					while (modelValue.length < 7) {modelValue = "0" + modelValue;}
					ctrl.$modelValue = modelValue;
					return formatCnae(modelValue);
				}
			};

			ctrl.$parsers.push(cnaeParser);
			ctrl.$formatters.push(cnaeFormatter);
		}
	};
});
